import * as Sentry from "@sentry/react";

// Initialize Sentry for deploy environments where monitoring is enabled.
const sentryEnabledModes = new Set(["production", "staging"]);

if (sentryEnabledModes.has(import.meta.env.MODE)) {
    Sentry.init({
        dsn: import.meta.env.VITE_SENTRY_DSN,
        environment: import.meta.env.MODE,
        release: __APP_VERSION__, // Using the app version already defined in vite.config.ts

        sendDefaultPii: true,

        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration({
                maskAllText: true,
                blockAllMedia: true,
            }),
            Sentry.browserProfilingIntegration(),
        ],

        // Tracing
        tracesSampleRate: 0.1, // 10% in prod
        tracePropagationTargets: ["localhost", /^https:\/\/.*\.aruzapest\.com/],

        // Session Replay
        replaysSessionSampleRate: 0.1, // 10% of all sessions
        replaysOnErrorSampleRate: 1.0, // 100% of sessions with errors

        // Logging
        enableLogs: true,

        // Profiling
        profilesSampleRate: 0.1, // 10% in prod

        // Additional useful options
        attachStacktrace: true,
        maxBreadcrumbs: 100,
        debug: false,

        // Ignore some common errors that aren't actionable
        ignoreErrors: [
            // Browser extension errors
            "top.GLOBALS",
            "chrome-extension://",
            "moz-extension://",
            // Network errors that are expected
            "NetworkError",
            "Failed to fetch",
            // ResizeObserver errors (harmless)
            "ResizeObserver loop limit exceeded",
        ],

        beforeSend(event, _hint) {
            // Filter out events from browser extensions
            if (event.exception) {
                const frames = event.exception.values?.[0]?.stacktrace?.frames;
                if (
                    frames &&
                    frames.some(
                        (frame) =>
                            frame.filename?.includes("chrome-extension://") ||
                            frame.filename?.includes("moz-extension://")
                    )
                ) {
                    return null;
                }
            }
            return event;
        },
    });
}
